import { render } from "./DMSCustomerDetails.vue?vue&type=template&id=43007f1f"
import script from "./DMSCustomerDetails.vue?vue&type=script&lang=js"
export * from "./DMSCustomerDetails.vue?vue&type=script&lang=js"

import "./DMSCustomerDetails.vue?vue&type=style&index=0&id=43007f1f&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__